export async function getImageDimensions(file: File): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
      });
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}

export async function estimateFileSize(
  width: number,
  height: number,
  format: string,
  quality: number
): Promise<string> {
  // Rough estimation based on dimensions and format
  const pixels = width * height;
  let bitsPerPixel: number;

  switch (format) {
    case 'image/jpeg':
      bitsPerPixel = (quality / 100) * 24;
      break;
    case 'image/png':
      bitsPerPixel = 32;
      break;
    case 'image/webp':
      bitsPerPixel = (quality / 100) * 20;
      break;
    default:
      bitsPerPixel = 24;
  }

  const estimatedBytes = (pixels * bitsPerPixel) / 8;
  
  // Apply compression ratio estimation
  const compressionRatio = format === 'image/jpeg' ? 10 : 
                          format === 'image/webp' ? 12 : 4;
  
  const finalSize = estimatedBytes / compressionRatio;

  // Format the size
  if (finalSize > 1024 * 1024) {
    return `${(finalSize / (1024 * 1024)).toFixed(1)} MB`;
  } else if (finalSize > 1024) {
    return `${(finalSize / 1024).toFixed(1)} KB`;
  }
  return `${Math.round(finalSize)} bytes`;
}